import React from "react";
import { FieldProps } from "formik";
import styled from "styled-components";
import { DropDownIcon } from "../assets/svg/DropDownIcon";
import Select, { components, OptionProps } from "react-select";
import { get } from "../utils/get";
import { ContainerProps } from "react-select/src/components/containers";
import { EmitAndSemanticDiagnosticsBuilderProgram } from "typescript";

export type DropDownOptionsProps = {
  value: string | number;
  label: string;
  icon?: JSX.Element;
}[];
export interface DropDownProps {
  options: DropDownOptionsProps;
  width?: string;
  height?: string;
  dropdownLabel?: string;
  backgroundColor?: string;
  isBordered?: boolean;
}

export const DropDownGroups = ({
  field: { value, name, onBlur },
  form: { setFieldValue, touched, errors },
  options,
  width,
  height,
  dropdownLabel,
  backgroundColor,
  isBordered,
  ...restSelect
}: FieldProps & DropDownProps) => {

  const CustomOptionsComponent = (
    props: React.PropsWithChildren<OptionProps<any>>
  ) => {
    return (
      <components.Option {...props}>
        {get(props, "data.icon") && (
          <span style={{ marginRight: "0.5em" }}>
            {get(props, "data.icon")}
          </span>
        )}
        {get(props, "data.label")}
        {get(props, "data.email")}
      </components.Option>
    );
  };
  const CustomSelectContainerComponent = ({
    children,
    ...props
  }: React.PropsWithChildren<ContainerProps<any>>) => {
    const selectProps = get(props, "selectProps.value.value");
    const selectOptions = get(props, "options", []);
    const selectedItem = selectOptions.filter((item: any) => {
      return item.value === selectProps;
    });

    return (
      <MainSelectContainer
        width={`${width || "30em"}`}
        height={`${height || "2.5em"}`}
        selectedItem={!!get(selectedItem, "[0].icon")}
        backgroundColor={backgroundColor}
        isBordered={isBordered}
      >
        {get(selectedItem, "[0].icon", <div />)}
        <components.SelectContainer {...props}>
          {children}
        </components.SelectContainer>
      </MainSelectContainer>
    );
  };

  const errorMessage = touched[name] && errors[name];
  //@ts-ignore

  return (
    <Container isLabelled={!!dropdownLabel}>
      {dropdownLabel && <DropDownLabel>{dropdownLabel}</DropDownLabel>}
      <Select
        value={value}
        onChange={(selectedOption) => {
          setFieldValue(name, selectedOption);
        }}
        onBlur={onBlur}
        isClearable
        options={options}
        styles={{
          control: (base) => ({
            ...base,
            fontSize: "12px",
            fontWeight: 600,
            color: "#214160",
            minHeight: "20px",
            border: 0,
            boxShadow: "none",
            backgroundColor: backgroundColor || "#fff",
          }),
          menu: (base) => ({
            ...base,
            fontSize: "0.75em",
            width: width || "30em",
            paddingBottom: "1rem",
            color: "#214160",
          }),
          singleValue: (base) => ({
            ...base,
            color: "#214160",
          }),
        }}
        components={{
          Option: CustomOptionsComponent,
          IndicatorSeparator: () => null,
          DropdownIndicator: () => <DropDownIcon style={{ marginRight: 10 }} />,
          SelectContainer: CustomSelectContainerComponent,
          ValueContainer: ({ children, ...props }: any) => {
                  let [values, input] = children;
                  if (Array.isArray(values)) {
                    const val = (i: number) => values[i].props.children;
                    const { length } = values;
                    switch (length) {
                      case 1:
                        values = `${val(0)} `;
                        break;
                      case 2:
                        values = `${val(0)} and ${val(1)} `;
                        break;
                      case 3:
                        values = `${val(0)}, ${val(1)} and ${val(2)}`;
                        break;
                      default:
                        const plural = values.length === 3 + 1 ? "" : "s";
                        const otherCount = length - 3;
                        values = `${val(0)}, ${val(1)}, ${val(
                          2
                        )} and ${otherCount} other${plural}`;
                        break;
                    }
                  }
                  return (
                    <components.ValueContainer {...props}>
                      {values}
                      {input}
                    </components.ValueContainer>
                  );
                }
        }}
        {...restSelect}
      />
      {/*
 // @ts-ignore */}
      {errorMessage && <ErrorText>{errorMessage?.label}</ErrorText>}
    </Container>
  );
};
const Container = styled.div<{ isLabelled: boolean }>`
  display: grid;
  grid-template-rows: ${(props) => props.isLabelled && "1.5em auto"};
`;

const DropDownLabel = styled.label`
  color: rgba(33, 65, 96, 0.4);
  font-weight: normal;
  font-size: 0.75em;
`;
const MainSelectContainer = styled.div<
  Omit<DropDownProps, "options"> & { selectedItem: boolean }
>`
  display: grid;
  align-items: center;
  grid-template-columns: ${(props) =>
    props.selectedItem ? " 1em auto" : "auto"};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  align-self: center;
  padding-right: 0.5em;
  padding-left: 0.5em;
  border: ${(props) => props.isBordered && "1px solid rgba(55, 81, 255, 0.1)"};
  border-radius: 0.5em;
  background-color: ${(props) => props.backgroundColor || "#fff"};
`;

const ErrorText = styled.p`
  margin: 0;
  color: red;
  font-size: 0.75em;
`;
